import { inject } from '@angular/core';
import { ResolveFn } from '@angular/router';
import { UserRole } from '@examdojo/models/user';
import { UserService } from '@examdojo/user';
import { catchError, map, of } from 'rxjs';

export const userRoleResolver: ResolveFn<UserRole | null> = () => {
  const userService = inject(UserService);

  return userService.fetchCurrentUserRole().pipe(
    map((role) => role ?? null), // Convert undefined to null
    catchError((error: unknown) => {
      console.warn('[userRoleResolver]: Failed to fetch user role', error);
      // Return null but don't block navigation - let guards handle authorization
      return of(null);
    }),
  );
};
